import React from 'react';
import { useTranslation } from 'react-i18next';
import { dateMonthYear } from '../../../utils/ts/date';
import { IconPlay } from '../Icon';
import {
  AuthorImage,
  AuthorName,
  AuthorRow,
  CardBody,
  Category,
  Excerpt,
  Eyebrow,
  Image,
  ImageContainer,
  TimeRow,
  Title,
  VideoIcon,
  Wrapper,
} from './wrappers';

interface IArticleCard {
  author?: {
    image: string;
    image2x?: string;
    name: string;
  };
  backplate?: boolean;
  category: string;
  date?: string;
  excerpt: string;
  eyebrow?: string;
  image?: string;
  readTime?: number;
  title: string;
  layout?: 'large' | 'medium' | 'small' | 'stacked';
  mirrored?: boolean;
  link: string;
  videoIcon?: boolean;
}

const ArticleCard = ({
  author,
  backplate,
  category,
  date,
  excerpt,
  eyebrow,
  image,
  layout = 'stacked',
  link,
  mirrored,
  readTime,
  title,
  videoIcon,
}: IArticleCard) => {
  const { t } = useTranslation();

  return (
    <Wrapper $layout={layout} $mirrored={mirrored} $backplate={backplate}>
      <ImageContainer>
        {videoIcon && (
          <VideoIcon>
            <IconPlay />
          </VideoIcon>
        )}
        <Image src={image} alt={title} />
      </ImageContainer>
      <CardBody>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <Category>{category}</Category>
        <Title to={link} title={title}>
          {title}
        </Title>
        <Excerpt>{excerpt}</Excerpt>
        {(readTime || date) && (
          <TimeRow>
            {readTime && <div>{t('readTime', { ns: 'article', readTime })}</div>}
            {date && <div>{dateMonthYear(date)}</div>}
          </TimeRow>
        )}
        {author && (
          <AuthorRow>
            {author.image && (
              <AuthorImage src={author.image} srcSet={author.image2x} alt={author.name} />
            )}
            <AuthorName>{author.name}</AuthorName>
          </AuthorRow>
        )}
      </CardBody>
    </Wrapper>
  );
};

export default ArticleCard;
